import {weightedCardSchema} from '../../../../../schemas/weightedCardSchema';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {DTWeightedNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertWeightedAICardToAPICard(
  weightedCard: z.infer<typeof weightedCardSchema>,
  existingCard: DTWeightedNode,
): DTWeightedNode {
  const outputs = weightedCard.outputs.map((output, index) => ({
    nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
    id: index + 1,
    name: output.name ?? `Output ${index + 1}`,
    weight: output.weight ?? 0,
  }));

  return {
    ...getAICardBaseDetails(weightedCard),
    ...weightedCard,
    type: NodeType.WEIGHTED,
    outputs: outputs,
    inputs: [],
  } as DTWeightedNode;
}
